<ng-container *ngIf="state$ | async as state">
  <div class="overlay-shell" *ngIf="state.isOpen && state.data as data">
    <section
      class="overlay-card"
      cdkDrag
      cdkDragBoundary=".overlay-shell"
      role="dialog"
      aria-modal="false"
      [attr.aria-label]="data.title"
    >
      <header class="overlay-header" cdkDragHandle>
        <span class="overlay-title">{{ data.title }}</span>
        <mat-icon class="overlay-handle" aria-hidden="true">drag_indicator</mat-icon>
      </header>

      <section class="overlay-contact">
        <div class="overlay-contact__details">
          <div class="overlay-contact__name">{{ data.contactName }}</div>
          <div class="overlay-contact__phone">{{ data.phoneNumber }}</div>
        </div>

        <div class="overlay-contact__icon" aria-hidden="true">
          <mat-icon>{{ data.callIcon }}</mat-icon>
        </div>
      </section>

      <section class="overlay-note">
        <label class="overlay-note__label" for="active-call-overlay-note">{{ data.noteLabel }}</label>
        <mat-form-field appearance="outline" class="overlay-note__field">
          <textarea
            id="active-call-overlay-note"
            matInput
            [formControl]="noteControl"
            [placeholder]="data.notePlaceholder"
            [rows]="4"
          ></textarea>
        </mat-form-field>
        <div class="overlay-note__counter">{{ noteLength }}/{{ maxNoteLength }}</div>
      </section>

      <footer class="overlay-actions">
        <button
          mat-flat-button
          color="primary"
          type="button"
          class="overlay-actions__primary"
          [disabled]="state.isSaving || noteControl.invalid"
          (click)="onSave()"
        >
          {{ data.saveButtonLabel }}
        </button>

        <button
          mat-stroked-button
          color="primary"
          type="button"
          class="overlay-actions__secondary"
          [disabled]="state.isSaving"
          (click)="onClose()"
        >
          {{ data.closeButtonLabel }}
        </button>
      </footer>
    </section>
  </div>
</ng-container>
